var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareStack3DUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.86 8.193l-7.83-4.27-7.828 4.27 7.829 4.034 7.829-4.034zm-7.111-5.587a1.5 1.5 0 00-1.437 0l-7.829 4.27c-1.056.576-1.038 2.1.032 2.65l7.829 4.034a1.5 1.5 0 001.374 0l7.829-4.034c1.07-.55 1.087-2.074.031-2.65l-7.829-4.27zm8.422 9.76a.75.75 0 01-.337 1.005l-7.803 3.883a2.25 2.25 0 01-2 .003l-7.863-3.885a.75.75 0 01.664-1.345l7.864 3.885a.75.75 0 00.666 0l7.804-3.884a.75.75 0 011.005.338zm-.337 5.005a.75.75 0 10-.668-1.342l-7.804 3.882a.75.75 0 01-.666.001l-7.864-3.884a.75.75 0 00-.664 1.344l7.864 3.885c.63.312 1.37.31 1.999-.003l7.803-3.883z",
    fill: "currentColor"
  })));
}
export default SvgSquareStack3DUp;